import {
    Alert,
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    FormControlLabel,
    FormGroup,
    InputLabel,
    MenuItem,
    Select,
    Typography
} from "@mui/material";

const TransferOpportunityDialog = ({
    open,
    mode, // "copy" | "move"
    sourceJourney,
    journeys,
    targetJourneyId,
    setTargetJourneyId,
    columns,
    targetColumnId,
    setTargetColumnId,
    loading,
    onClose,
    onConfirm,

    // só usado no COPY
    copyOptions,
    setCopyOptions,
}) => {
    const actionLabel = mode === "move" ? "Mover" : "Copiar";

    const filteredJourneys = (journeys || []).filter(j => j.id !== sourceJourney?.id);

    const showCopyOptions = mode === "copy";

    const markAll = () => {
        setCopyOptions(prev => Object.fromEntries(Object.keys(prev).map(k => [k, true])));
    };

    const unmarkAll = () => {
        setCopyOptions(prev => Object.fromEntries(Object.keys(prev).map(k => [k, false])));
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>{actionLabel} oportunidade</DialogTitle>

            <DialogContent>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    {mode === "move" && (
                        <Alert severity="warning">
                            Ao mover, a oportunidade será copiada para o destino e removida da jornada atual.
                        </Alert>
                    )}

                    <FormControl size="small" fullWidth>
                        <InputLabel>Jornada de destino</InputLabel>
                        <Select
                            label="Jornada de destino"
                            value={targetJourneyId || ""}
                            onChange={(e) => setTargetJourneyId(Number(e.target.value))}
                        >
                            {filteredJourneys.map(j => (
                                <MenuItem key={j.id} value={j.id}>
                                    {j.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl size="small" fullWidth disabled={!targetJourneyId}>
                        <InputLabel>Coluna de destino</InputLabel>
                        <Select
                            label="Coluna de destino"
                            value={targetColumnId || ""}
                            onChange={(e) => setTargetColumnId(Number(e.target.value))}
                        >
                            {(columns || []).map(col => (
                                <MenuItem key={col.id} value={col.id}>
                                    {col.title}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    {showCopyOptions && (
                        <>
                            <Divider />

                            <Box>
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                                    <Typography variant="subtitle2">O que copiar</Typography>
                                    <Box sx={{ display: "flex", gap: 1 }}>
                                        <Button size="small" onClick={markAll}>Marcar todos</Button>
                                        <Button size="small" onClick={unmarkAll}>Desmarcar todos</Button>
                                    </Box>
                                </Box>

                                <FormGroup>
                                    <FormControlLabel
                                        control={<Checkbox checked={!!copyOptions?.status}
                                            onChange={(e) => setCopyOptions(p => ({ ...p, status: e.target.checked }))} />}
                                        label="Status"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={!!copyOptions?.description}
                                            onChange={(e) => setCopyOptions(p => ({ ...p, description: e.target.checked }))} />}
                                        label="Descrição"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={!!copyOptions?.value_currency}
                                            onChange={(e) => setCopyOptions(p => ({ ...p, value_currency: e.target.checked }))} />}
                                        label="Valor e moeda"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={!!copyOptions?.owner}
                                            onChange={(e) => setCopyOptions(p => ({ ...p, owner: e.target.checked }))} />}
                                        label="Vendedor"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={!!copyOptions?.contact_enterprise}
                                            onChange={(e) => setCopyOptions(p => ({ ...p, contact_enterprise: e.target.checked }))} />}
                                        label="Empresa"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={!!copyOptions?.contact}
                                            onChange={(e) => setCopyOptions(p => ({ ...p, contact: e.target.checked }))} />}
                                        label="Contato"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={!!copyOptions?.secondary_contacts}
                                        onChange={(e) => setCopyOptions(p => ({ ...p, secondary_contacts: e.target.checked }))} />}
                                        label="Outros contatos"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={!!copyOptions?.estimated_at}
                                        onChange={(e) => setCopyOptions(p => ({ ...p, estimated_at: e.target.checked }))} />}
                                        label="Estimada para"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={!!copyOptions?.closed_at}
                                            onChange={(e) => setCopyOptions(p => ({ ...p, closed_at: e.target.checked }))} />}
                                        label="Fechada em"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={!!copyOptions?.tags}
                                            onChange={(e) => setCopyOptions(p => ({ ...p, tags: e.target.checked }))} />}
                                        label="Marcadores"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={!!copyOptions?.custom_fields}
                                        onChange={(e) => setCopyOptions(p => ({ ...p, custom_fields: e.target.checked }))} />}
                                        label="Campos personalizados"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={!!copyOptions?.history}
                                        onChange={(e) => setCopyOptions(p => ({ ...p, history: e.target.checked }))} />}
                                        label="Histórico"
                                    />
                                </FormGroup>
                            </Box>
                        </>
                    )}
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} disabled={loading}>Cancelar</Button>
                <Button
                    variant="contained"
                    onClick={onConfirm}
                    disabled={loading || !targetJourneyId || !targetColumnId}
                >
                    {actionLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TransferOpportunityDialog;
